// TODO: Move to shared or fix the backend or something
import {
    formatDate,
    billingFrequencyInDaysToMonthInteger,
} from '@get-mosh/msh-shared';
import { camelCase, isArray, transform, isObject } from 'lodash';
import { PlanConfigurationResponse } from 'src/hooks/Checkout/usePlanConfiguration';
import { z } from 'zod';

export const camelizeObjectKeys = (obj: Record<string, unknown>) =>
    transform(
        obj,
        (
            result: Record<string, unknown>,
            value: unknown,
            key: string,
            target,
        ) => {
            const camelKey = isArray(target) ? key : camelCase(key);
            result[camelKey] = isObject(value)
                ? camelizeObjectKeys(value as Record<string, unknown>)
                : value;
        },
    );

export const validateEmail = (email: string) => {
    const result = z
        .email({
            error: (iss) =>
                iss.input === ''
                    ? 'Please provide an email address'
                    : 'Please enter a valid email address',
        })
        .safeParse(email);
    return result;
};

export const addPercentage = (value: number, percentage: number) => {
    return Math.round(value + value * (percentage / 100));
};

export const getNextRefillDate = (planConfig: PlanConfigurationResponse) => {
    const today = new Date();
    const nextRefillDate = new Date(today);
    nextRefillDate.setDate(
        today.getDate() + planConfig?.availablePlans[0].billingFrequencyInDays,
    );
    return formatDate(nextRefillDate);
};

export const formatInitialFrequency = (frequency: number) => {
    const months = billingFrequencyInDaysToMonthInteger(frequency);

    if (months === 1) {
        return 'the first month';
    } else {
        return `the first ${months} months`;
    }
};

export const formatScheduledFrequency = (frequency: number) => {
    const months = billingFrequencyInDaysToMonthInteger(frequency);

    if (months === 1) {
        return 'every month';
    } else {
        return `every ${months} months`;
    }
};
